/**
 * @module views\psm\batch\components\batchView
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Mixins } from "vue-property-decorator";
import GhInvoke from "@/components/ghInvoke/ghInvoke";
import { invoke } from "@/utils/api";
import SlotName from "@/components/mixins/slotName";

@Component
export default class BatchView extends Mixins(SlotName) {
  private pagination = {};

  @Prop()
  private headers!: ITableHeader[];

  @Prop({
    default: () => {
      return {
        date: "",
        structure_id: "",
        pagination: {}
      };
    }
  })
  private args!: IndexObject;

  @Watch("tableOptions")
  private observeTableOptions() {
    if (this.tableOptions) {
      if (this.tableOptions.headers) {
        this.$emit("update:headers", this.tableOptions.headers);
      }
    }
  }

  private tableOptions: ITableState | any = {};

  @Watch("pagination")
  private query() {
    let inovke = this.$refs.invoke as GhInvoke;
    if (invoke) {
      this.args.pagination = this.pagination;
      inovke.invoke(this.args);
    }
  }

  mounted() {
    this.query();
  }

  // private getCellName(prop:ITableHeader) {
  //   return "table-cell-" + prop.value;
  // }
}
